<template>
  <div>
    <CandidateLayout>
      <div
        v-if="!isJobConcluded"
      >
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-12 col-12">
              <div class="row">
                <div class="mt-3 col-lg-12 col-xs-12 center">
                  <img
                    src="/images/Jovool_logo.png"
                    width="120px"
                  />
                </div>
              </div>
              <div
                v-if="!isJobConcluded || job.uid != '3xw0ptkh'"
                class="row"
              >
                <div class="col-lg-3 col-12"></div>
                <div class="col-lg-6 col-12">
                  <transition
                    name="fade"
                    mode="out-in"
                    apper
                  >
                    <StepIndicator
                      v-if="!step_final"
                      class="mt-3"
                      defaultColor="#53358b"
                      :currentColor="'#00a0d6'"
                      :current="setup_index"
                      :total="total_steps"
                    ></StepIndicator>
                  </transition>
                </div>
              </div>
              <transition
                name="fade"
                mode="out-in"
                appear
              >
                <Register
                  v-if="step_register"
                  :job="job"
                  :selective_process="selective_process"
                  :candidate_data="candidate"
                  :account_uid="account_uid"
                  :extra_options="extra_options"
                  :apply="apply"
                  :mandatory_questions="mandatory_questions"
                />

                <DataCollect
                  v-if="step_data_collect"
                  :selective_process_uid="selective_process_uid"
                />

                <Experience
                  v-if="step_historical"
                  :candidate_data="candidate"
                  :job="job"
                />
                <ConfirmExperience
                  v-if="step_confirm"
                  :account_uid="account_uid"
                  :job="job"
                />
                <div v-if="step_videos">
                  <div v-if="(
                    evaluations
                    && show_evaluation
                    && evaluations.length > 0
                  )">
                    <Evaluations
                      :evaluations="evaluations"
                      :account_uid="account_uid"
                      :candidate="candidate"
                      :selective_process_uid="selective_process_uid"
                      class="mt-2"
                    />
                  </div>
                  <Questions
                    class="mt-2"
                    :account_uid="account_uid"
                    :job_questions="questions"
                    v-if="(
                      step_videos && !show_evaluation
                    )"
                    :selective_process_uid="selective_process_uid"
                  />
                </div>
                <div
                  class="card card-body mt-2 text-dark bg-white"
                  v-if="step_bigfive"
                  style="height: 100%; overflow: scroll; overflow-x: hidden"
                >
                  <Bigfive
                    :bigfive_uid="bigfive.uid"
                    :candidate_uid="candidate_uid"
                    :amount_itens="bigfive.amount_itens"
                    :account_uid="account_uid"
                    :no_next="false"
                  />
                </div>

                <Congratulation
                  class="mt-3"
                  v-if="step_final"
                  :job="job"
                  :account_uid="account_uid"
                  :show="false"
                  :label="congratulation_label"
                />
              </transition>
            </div>
          </div>
        </div>
      </div>
    </CandidateLayout>
  </div>
</template>

<script>
import { required, email, minLength } from "vuelidate/lib/validators";
import StepIndicator from "vue-step-indicator";
import Register from "@/Candidates/Applies/Register.vue";
import DataCollect from "@/Candidates/Applies/DataCollect.vue";
import Experience from "@/Candidates/Applies/Experience.vue";
import ConfirmExperience from "@/Candidates/Applies/ConfirmExperience.vue";
import Evaluations from "@/Candidates/Applies/Evaluations.vue";
import Questions from "@/Jobs/Questions.vue";
import Bigfive from "@/Bigfives/Test.vue";
import Congratulation from "@/Jobs/Congratulation.vue";
import CandidateLayout from "layouts/Candidate.vue";

export default {
  props: [
    "job_uid",
    "account_uid",
    "job_link",
    "job",
    "apply",
    "evaluations",
    "questions",
    "mandatory_questions",
    "candidate_uid",
    "bigfive",
    "candidate",
    "selective_process",
    "selective_process_uid",
    "extra_options"
  ],
  components: {
    DataCollect,
    StepIndicator,
    Register,
    Experience,
    Evaluations,
    Questions,
    Bigfive,
    Congratulation,
    ConfirmExperience,
    CandidateLayout
  },
  data: () => ({
    load: false,
    error_linkedin: false,
    step_register: true,
    step_data_collect: false,
    step_historical: false,
    step_confirm: false,
    step_videos: false,
    step_bigfive: false,
    step_final: false,
    setup_index: 0,
    total_steps: 3,
    show_evaluation: true,
    show_evaluation_introduction: true,
    congratulation_label: null,
    user: {
      email: "",
      name: "",
      password: "",
      accept_terms: false,
    },
  }),
  mounted() {
    if (this.questions?.length > 0) {
      this.show_evaluation = false;
    }
    document.body.classList.add("body_sign_up_grey");
    if (this.job.bigfive != false) {
      this.total_steps = 4;
    }

    eventBus.$on("RegisterFinished", (record) => {
      this.disableSteps();
      this.setup_index = 1;
      if (this.job.hide_upload_cv && !this.job.ask_remuneration) {
        eventBus.$emit("ExperiencieFinished");
        return;
      }

      this.step_historical = true;
    });

    eventBus.$on("DataCollecFinished", (record) => {
      this.disableSteps();
      this.step_data_collect = true;
    });

    eventBus.$on("ExperiencieFinished", (record) => {
      this.disableSteps();
      this.setup_index = 1;
      if (this.job.hide_confirm_experiences) {
        eventBus.$emit("ConfirmFinished");
        return;
      }

      this.step_confirm = true;
    });

    eventBus.$on("ConfirmFinished", (record) => {
      this.disableSteps();
      this.setup_index = this.total_steps - 1;
      if (this.job.allow_unlimited_chances) {
        this.candidate.view_evaluation = 0;
      }
      if (this.candidate.view_evaluation <= 2){        
        if (
          this.questions?.length > 0 ||
          this.evaluations?.length > 0
        ) {
          this.congratulation_label = this.evaluations?.length 
            ? "PROVA CONCLUÍDA COM SUCESSO"
            : null;
          this.step_videos = true;
          return;
        } 
        if (this.bigfive != 0) {
          this.setup_index = 3;
          this.step_bigfive = true;
          return;
        }
        this.step_final = true;
      } else {
        if (this.bigfive != 0) {
          this.setup_index = 3;
          this.step_bigfive = true;
          return;
        }
        this.step_final = true;
      }
    });

    eventBus.$on("finalScreen", () => {
      if (this.evaluations.length > 0 && !this.show_evaluation) {
        return this.show_evaluation = true;
      }
      this.disableSteps();
      if (this.bigfive != 0) {
        this.setup_index = 3;
        this.step_bigfive = true;
      } else {
        this.step_final = true;
      }
    });

    eventBus.$on("gotoFinal", () => {
      this.disableSteps();
      this.step_final = true;
    });

    // if (this.apply.completed) {
    //   this.disableSteps();
    //   this.setup_index = 1;
    //   this.step_confirm = true;
    // }
  },
  methods: {
    disableSteps() {
      this.step_register = false;
      this.step_data_collect = false;
      this.step_historical = false;
      this.step_confirm = false;
      this.step_videos = false;
      this.step_bigfive = false;
      this.step_final = false;
    },
    showEvaluationStart(status) {
      this.show_evaluation_introduction = status;
    },
    destroySession() {
      axios
        .delete(
          "/candidates/sessions?job_uid=" +
            this.job.uid +
            "&account_uid=" +
            this.account_uid
        )
        .then((response) => {
          location.reload();
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  computed: {
    validForm() {
      if (this.$v.user.$invalid) return false;

      if (!this.user.accept_terms) return false;
      return true;
    },
    isJobConcluded() {
      const date = new Date();
      const conclution_date = new Date(this.job.date_conclusion);
      let candidate_created_at = new Date(this.candidate.created_at);
      if(date > conclution_date && candidate_created_at > conclution_date) {
        this.destroySession();
        return true;
      } else {
        return false
      }
    },
  },
  validations: {
    user: {
      email: { required, email },
      name: { required },
      password: { required, minLength: minLength(6) },
    },
  },
};
</script>

<style >
body {
  height: 100%;
  margin: 0;
}

.sign_up_form {
  color: #303946;
  margin: 0px auto;
}

.btn-border {
  border: 1px solid #ccc;
  border-radius: 4px;
}
</style>